import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-015e50c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cell-custom" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px"} }, null, -1))
const _hoisted_3 = { class: "i-content" }
const _hoisted_4 = { class: "row-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_DateTimePicker = _resolveComponent("DateTimePicker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_cell, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "cell-custom",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickSelectDateEvent && _ctx.onClickSelectDateEvent(...args)))
          }, [
            _createVNode(_component_van_icon, {
              name: "clock-o",
              class: "search-icon"
            }),
            _createElementVNode("div", null, _toDisplayString(_ctx.startTimeStanding) + " - 当前", 1)
          ]),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              style: {"border":"1px solid #6A4DB9","padding":"5px","border-radius":"6px"},
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.roadIdStanding) = $event)),
              placeholder: "请输入车牌"
            }, null, 512), [
              [_vModelText, _ctx.roadIdStanding]
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
      finished: _ctx.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.onMoreLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, { key: item }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showBottomPopup,
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DateTimePicker, {
          title: "选择日期",
          onBindConfirm: _ctx.confirmSelectDate,
          onBindCancel: _ctx.cancelSelectDate
        }, null, 8, ["onBindConfirm", "onBindCancel"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}